<template>
  <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Funcionários</h5>
                <hr>
                <div class="p-grid">
                    <div class="p-col-12 p-md-6">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-12">
                                <label>Empresa</label>
                                <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                                    @change="listarCentrosCustos"/>
                            </div>   
                            <div class="p-field p-col-12 p-md-6">                           
                                <div class="p-field-checkbox">
                                    <Checkbox v-model="ativo" :binary="true"/>
                                    <label>Ativo</label>
                                </div>
                            </div>                      
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <div class="p-fluid p-formgrid p-grid">                            
                            <div class="p-field p-col-9">
                                <label>Centro de custo</label>               
                                <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Todos"
                                    :filter="true" :showClear="true"/>
                            </div> 
                            <div class="p-field p-col-0">
                                <label style="color:#ffffff">.</label>  
                                <Button label="Buscar" icon="pi pi-search" @click="listarPorFiltros()"/>
                            </div>   
                            <div class="p-field p-col-9 p-md-9">                        
                                <div class="p-inputgroup">
                                    <InputText v-model.trim="crachaNome" 
                                    @keyup.enter="listarPorFiltros()" 
                                    @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')" 
                                    placeholder="crachá/pis/cpf/nome"/>
                                    <Button icon="pi pi-search" title="Buscar" @click="listarPorFiltros()"/>                    
                                </div>
                            </div>          
                        </div>
                    </div>
                </div>

                <DataTable :value="funcionarios" class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">	
							<div class="p-d-flex p-jc-between">		
                                <div>
                                    <Button label="Novo" icon="pi pi-plus" @click="novo" :disabled="bloquearEnivo"/>
                                    <Button label="Exportar" icon="pi pi-download" class="p-ml-2" title="Exporta para arquivo CSV" @click="selecionarOpcaoExportar" :disabled="bloquearEnivo"/>
                                    <Button label="Importar" icon="pi pi-upload" class="p-ml-2" title="Importar do CSV" @click="irParaImportacao" :disabled="bloquearEnivo"/>
                                    <IKMonitoramentoDocumentos  ref="ikMonitoramentoDocumentos" :callback="finalizarProcessarCSV"/>  
                                </div>	
							</div>
						</div>
					</template>
					<Column field="cracha" header="Crachá"></Column>
					<Column field="nome" header="Nome"></Column>
					<Column field="cargo" header="Cargo"></Column>
					<Column field="centroCusto" header="Centro de Custo"></Column>	
					<Column field="escala" header="Escala"></Column>	
					<Column field="dataCadastro" header="Cadastro"></Column>	
                    <Column>
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2"
                             @click="editar(slotProps.data)" v-if="permissaoEditar"/>
                            <Button icon="pi pi-calendar" title="Editar Data para Ativação" class="p-button-rounded p-button-info p-mr-2"
                             @click="editarDataAtivacao(slotProps.data)" v-if="permissaoEditar && slotProps.data.aguardandoAtivacao"/>							
						</template>
					</Column>
				</DataTable>

                <Paginacao ref="paginacao" :qtdLinhasPorPagina="[10,15,20,30]" :callback="listarPorPagina"/>

			</div>
		</div>

        <Dialog :visible.sync="exibirDialogOpcaoExportar" header="Exportar para CSV" :modal="true" class="p-fluid">	
            <div class="p-formgroup-inline">
                <div class="p-field-radiobutton">
                    <RadioButton name="opcaoExportar" value="FILTRO_TELA" v-model="opcaoExportar"/>
                    <label>Exportar do Filtro da Tela</label>
                </div>
                <div class="p-field-radiobutton">
                    <RadioButton name="opcaoExportar" value="TODOS" v-model="opcaoExportar"/>
                    <label>Exportar Todos</label>
                </div>
            </div>						
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary p-mt-6" @click="exibirDialogOpcaoExportar = false"/>
                <Button label="Exportar" icon="pi pi-check" @click="processar" />
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogDataAtivacao" header="Data para Ativação" :modal="true" :style="{width: '40vw'}">
            <div class="p-fluid p-formgrid p-grid" v-if="funcionarioDataAtivacao">						
                <div class="p-field p-col-12 p-md-7">
                    <label>Funcionário</label>
                    <InputText v-model="funcionarioDataAtivacao.nome" readonly/>
                </div>
                <div class="p-field p-col-12 p-md-5">
                    <label>Centro de Custo</label>
                    <InputText v-model.trim="funcionarioDataAtivacao.centroCusto" readonly/>
                </div>
            </div>			
			<div class="p-fluid p-formgrid p-grid" v-if="funcionarioDataAtivacao">	
				<div class="p-field p-col-12 p-md-12">	
					<p class="p-text-bold">Ativação em {{ funcionarioDataAtivacao.dataAtivacao }}</p>
					<p id="pLimitesDataAtivacao">Selecione uma data para ativação. Limites: {{ limitesDataAtivacao() }}</p>				
					<Calendar v-model="dataAtivacao" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" appendTo="body" :locale="localeCalendarBR"/>	
				</div>				
			</div>
			<template #footer>				
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogDataAtivacao=false"></Button>
				<Button label="Salvar" icon="pi pi-check" @click="alterarDataAtivacao"></Button>			
			</template>
		</Dialog>

  </div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import IKMonitoramentoDocumentos from '@/components/template/IKMonitoramentoDocumentos';
import FuncionarioService from '@/service/FuncionarioService';
import CentroCustoService from '@/service/CentroCustoService';
import Paginacao from '@/components/template/Paginacao.vue';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters, mapActions } from 'vuex';

export default {
    relatorioService: null,
    funcionarioService: null,
    centroCustoService: null,
    data() {
        return {
            opcaoExportar: 'FILTRO_TELA',
            exibirDialogDataAtivacao: false,
            exibirDialogOpcaoExportar: false,
            permissaoNovo: false,
            permissaoEditar: false,
            ativo: true,
            buscandoAtivo: false,
            idCnpjSelecionado: null,
            cnpjs: [],
            idCentroCustoSelecionado: null,
            centrosCustos: [],
            crachaNome: '',
            funcionarios: [],
            filtro: {},
            qtdLinhasPorPagina: 10,
            numPagina: 1,
            localeCalendarBR: localeCalendarBR,
            dataAtivacao: new Date(),
            funcionarioDataAtivacao: null,
            bloquearEnivo: false
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes', 'getCacheEmpresa']),	
        ...mapActions('sessao', ['atualizarCacheEmpresa']),
        irParaImportacao() {
            this.$router.push('/cadastros/funcionarios/importar');
        },
        novo() {
            this.$router.push('/cadastros/funcionarios/novo');
        },
        editar(funcionario) {
            let cacheDados = sessionStorage.getItem('CACHE_DADOS_FUNCIONARIOS');  
            if(cacheDados != null) {
                let dados = JSON.parse(cacheDados);
                dados.idFuncionario = funcionario.id
                sessionStorage.setItem('CACHE_DADOS_FUNCIONARIOS', JSON.stringify(dados)); 
            }
			this.$router.push('/cadastros/funcionarios/'+funcionario.id+'/editar?at='+funcionario.ativo);
		},
        editarDataAtivacao(funcionario) {
            let amanha = new Date();
			amanha.setDate(amanha.getDate() + 1);				
			this.dataAtivacao = amanha;
            this.funcionarioDataAtivacao = funcionario,
            this.exibirDialogDataAtivacao = true;
        },
        selecionarOpcaoExportar() {
            this.exibirDialogOpcaoExportar = true;
        },
        listarPorPagina(paginacao) {
            this.numPagina = paginacao.pagina;
            this.qtdLinhasPorPagina = paginacao.linhas;
            this.listar();
        },
        listarPorFiltros() {
            this.numPagina = 1;
            this.$refs.paginacao.paginar(1);
        },
        alterarDataAtivacao() {
            let umDia = 86400000;
			let hoje = new Date((new Date().getTime() + umDia));
			let limite = new Date((new Date().getTime() + (umDia * 6)));
			hoje.setHours(0,0,0,0);
			limite.setHours(0,0,0,0);			
			this.dataAtivacao.setHours(0,0,0,0);			
			if(this.dataAtivacao.getTime() < hoje.getTime() || this.dataAtivacao.getTime() > limite.getTime()) {
				if(document.getElementById('pLimitesDataAtivacao')) {
					document.getElementById('pLimitesDataAtivacao').classList.add('ik-text-danger');
				}
				return;
			}	
            let requisicao = {
				idFuncionario: this.funcionarioDataAtivacao.id,
				dataAtivacao: this.formatarData(this.dataAtivacao),				
				usuarioRequisicao: {...this.getDadosRequisicao()},
			};		
            this.funcionarioService.alterarDataAtivacao(requisicao)
            .then(resp => {                   
                this.exibirDialogDataAtivacao = false;
                exibirMensagem(this, resp);
                this.funcionarios.forEach(funcio => {
                    if(funcio.id == this.funcionarioDataAtivacao.id) {                     
                        let mes = this.dataAtivacao.getMonth();
                        let dia = this.dataAtivacao.getDate();
                        let strData = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + this.dataAtivacao.getFullYear();
                        funcio.dataAtivacao = strData;
                    }
                })
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        listar() {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }
            let requisicao = {
                qtdLinhas: this.qtdLinhasPorPagina,
                numPagina: this.numPagina,
                crachaNome: this.crachaNome,
                ativo: this.ativo,
                idsCentrosCustos: idsCentrosCustos,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            this.funcionarioService.listar(requisicao)
            .then(resp => {                   
                this.$refs.paginacao.atualizar(resp.data.qdtFuncionarios);                       
                this.funcionarios = resp.data.funcionarios;
                this.atualizarCacheDados(resp.data.qdtFuncionarios);
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        processar() {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let requisicao = {
                nomeDocumento: 'Detalhes Funcionários',
                nomeArquivo: 'Detalhes_Funcionarios',
                servico: 'funcionarioCSV',
                tipoDocumento: 'csv',
                cnpj: null,
                idsFuncionarios: [],
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            requisicao.cnpj = this.cnpjs.find(cnpj => cnpj.id == this.idCnpjSelecionado);             
            if(this.opcaoExportar != 'TODOS') {
                this.funcionarios.forEach(func => {
                    requisicao.idsFuncionarios.push(func.id);
                });              
            }            
            this.relatorioService.processar(requisicao)
            .then(resp => {                   
                this.exibirDialogOpcaoExportar = false;
                this.bloquearEnivo = true;
                this.$refs.ikMonitoramentoDocumentos.iniciarMonitoramento(resp.data); 
            })
            .catch(erro => { 
                exibirMensagem(this, erro);
            });            
        },
        /**
         * 
         */
        finalizarProcessarCSV() {
            this.bloquearEnivo =  false;
        },
        listarCnpjs() {
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
            // Dado do filtro de funcionários
            this.validarCacheDados();
        },
        listarCentrosCustos() {
            this.funcionarios = [];
            let cacheEmpresa = this.getCacheEmpresa();
            cacheEmpresa.idCnpjSelecionado = this.idCnpjSelecionado; 
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => {     
                 // Cache dados      
                cacheEmpresa.centrosCustos = [];              
                resp.data.forEach(ct => {
                    cacheEmpresa.centrosCustos.push({...ct});
                });                  
                this.idContratoSelecionado = null;                     
                this.centrosCustos = []; 
                let centroCusto = new CentroCusto();
                centroCusto.nome = 'Todos';
                this.centrosCustos.push(centroCusto);
                Array.prototype.push.apply(this.centrosCustos, resp.data);    
                this.atualizarCacheEmpresa(cacheEmpresa);                 
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        limitesDataAtivacao() {
            let umDia = 86400000;
			let hoje = new Date((new Date().getTime() + umDia));			 		
			let setDias = new Date((new Date().getTime() + (umDia * 6)));		
			let mes = hoje.getMonth();
			let dia = hoje.getDate();
			let dataDe = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + hoje.getFullYear();		
			mes = setDias.getMonth();
			dia = setDias.getDate();
			let dataAte = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + setDias.getFullYear();
			return dataDe + ' - ' + dataAte;
		},
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(25);
			this.permissaoEditar = permissoes.includes(26);				
		},
        // Dados filtrados na sessionStorage
        validarCacheDados() {
            let cacheDados = sessionStorage.getItem('CACHE_DADOS_FUNCIONARIOS');             
            // Esse atribuo foi definido no router.beforeEach em router.js
            if(window.urlAnteriorSelecionada.includes('/cadastros/funcionarios') 
                && (window.urlAnteriorSelecionada.length > '/cadastros/funcionarios'.length)
                && cacheDados != null) {         
                let dados = JSON.parse(cacheDados);         
                this.idCnpjSelecionado = dados.idCnpjSelecionado;
                this.idCentroCustoSelecionado = dados.idCentroCustoSelecionado;  
                this.centrosCustos = dados.centrosCustos;
                this.crachaNome = dados.crachaNome;
                this.ativo = dados.ativo;
                this.mesAno = new Date(dados.mesAno);          
                this.numPagina = dados.numPagina;
                this.funcionarios = dados.funcionarios;
                this.$refs.paginacao.atualizar(dados.qdtFuncionarios);      
                this.$refs.paginacao.paginarSemAtualizarDados(dados.numPagina);  
            } else {                
                sessionStorage.removeItem('CACHE_DADOS_FUNCIONARIOS');
            }
        },
        // Dados filtrados na sessionStorage
        atualizarCacheDados(qdtFuncionarios) {
            let cacheDados = {
                idCnpjSelecionado: this.idCnpjSelecionado,
                idCentroCustoSelecionado: this.idCentroCustoSelecionado,  
                centrosCustos: this.centrosCustos,
                crachaNome: this.crachaNome,
                ativo: this.ativo,
                mesAno: this.mesAno,          
                numPagina: this.numPagina,
                qdtFuncionarios: qdtFuncionarios,
                funcionarios: this.funcionarios,
                idFuncionario: 0,
            }
            sessionStorage.setItem('CACHE_DADOS_FUNCIONARIOS', JSON.stringify(cacheDados));
        },
    },	
	created() {
        this.relatorioService = new RelatorioService();
        this.funcionarioService = new FuncionarioService();		
        this.centroCustoService = new CentroCustoService();		
	},
	mounted() {	
        this.validarPermissoes();		
        this.listarCnpjs();			
	},
    components: {
        'Paginacao': Paginacao,
        'IKMonitoramentoDocumentos': IKMonitoramentoDocumentos
    }
}
</script>

<style>

</style>